import React from 'react';

const NoteSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M17.548 17.998H1.998V2.005H22V22l-4.451-4.002zM21 19.905V3H3.003v14h14.984L21 19.905zM8 9.5h3.5V6h.996v3.5h3.508v1h-3.508V14H11.5v-3.5H8v-1z"
            fillRule="nonzero"
        />
    </svg>
);

NoteSvg.displayName = 'NoteSvg';
export default NoteSvg;
